import React from 'react';
import {
  AccordionItem,
  AccordionHeader,
  AccordionPanel,
  AccordionIcon,
} from '@chakra-ui/core';
import { pxToRem } from '../../utils/dimensionConverter';
import { gtag } from '../../libs/analytics';

export const ListItem = ({ title, url, isEducation = false }) => {
  const handleClick = () => {
    gtag('event', 'education_center_views_downloads', {
      education_item: title,
    });
  }
  
  //Titles comes as "Horizon & Braven HealthSM QRG" from the backend.
  let formattedTitle = title;
  const smIndex = formattedTitle.indexOf('SM ');
  if (smIndex > 0) {
    formattedTitle = (
      <>
        {formattedTitle.substring(0, smIndex)}
        <sup>SM</sup>
        {formattedTitle.substring(smIndex + 2)}
      </>
    );
  }

  return (
    <li class="card__list-item no-capitalize">
      <div class={isEducation ? 'card__list-education' : 'card__list-name'}>
        <a target="_blank" href={url} onClick={handleClick}>
          {formattedTitle}
        </a>
      </div>
      <div class="card__list-description">
        <a target="_blank" href={url} onClick={handleClick}>
          <div class="icon icon-link"></div>
        </a>
      </div>
    </li>
  );
};

export const CardList = ({ title, children, idName }) => {
  return (
    <section class="section-card doc-list" id={idName}>
      <h3 class="section-card__title">{title}</h3>
      <ul class="card__list ">{children}</ul>
    </section>
  );
};

export const DropDownItem = ({ title, children }) => {
  return (
    <AccordionItem className="dropdown-item">
      <AccordionHeader>
        <span>{title}</span>
        <AccordionIcon />
      </AccordionHeader>
      <AccordionPanel className="dropdown-panel" pb={pxToRem(4)}>
        {children}
      </AccordionPanel>
    </AccordionItem>
  );
};
